/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/details" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdDetails } from "./constants";
import type { GetDecisioningStudioAgentsAppGroupIdDsaIdDetailsResult } from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdDetailsResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdDetails = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdDetails,
  (
    signal: AbortSignal,
    appGroupId: string,
    dsaId: string
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdDetailsResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/details`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdDetailsResult
);
